<template>
  <SidebarLayout
    class="projects-page"
    :classname="'section-projects' + (!incomingProjects.length && !loading ? ' empty' : '')"
  >
    <div class="top">
      <div class="text-bs grey-900">
        {{ $t('Incoming tenders') }}
      </div>
      <FilterTabs
        :value="currentStatus"
        :tabs="statusFilterTabs"
        query="status"
        @change="handleStatusChanging"
      />
    </div>
    <div ref="scroll">
      <ScrollPagination v-model="incomingProjects" :url="nextUrl" class="main spacey-12">
        <TenderCard v-for="(tender, idx) in incomingProjects" :key="idx" :tender="tender" />
        <TenderCardSkeleton v-if="loading" />
      </ScrollPagination>
    </div>
  </SidebarLayout>
</template>

<script>
  import SidebarLayout from '@/layouts/SidebarLayout';
  import TenderCard from '@/containers/incoming-tender/TenderCard';
  import FilterTabs from '@/components/ui/FilterTabs';
  import factory from '@/utils/api/factory';
  import ScrollPagination from '@/containers/common/ScrollPagination';
  import TenderCardSkeleton from '@/skeletons/project/tenders/TenderCardSkeleton';
  import getOptimalLimit from '@/utils/api/optimal-limit';

  export default {
    meta: {
      title: 'Incoming tenders',
    },
    components: {
      SidebarLayout,
      TenderCard,
      FilterTabs,
      ScrollPagination,
      TenderCardSkeleton,
    },
    async mounted() {
      if (this.$route.query.status) {
        this.currentStatus = this.$route.query.status;
      }
      await this.loadIncomingTenders();
    },
    data() {
      return {
        statusFilterTabs: [
          {
            title: this.$t('Active'),
            slug: 'active',
          },
          {
            title: this.$t('Rejected'),
            slug: 'rejected',
          },
        ],
        currentStatus: 'active',
        incomingProjects: [],
        nextUrl: null,
        loading: false,
      };
    },
    methods: {
      async loadIncomingTenders() {
        this.loading = true;
        try {
          this.incomingProjects = [];
          let { data } = await factory('incoming_tenders').indexInPath('offers', {
            ...(this.currentStatus === 'active'
              ? {
                  not_status: 'declined',
                }
              : {
                  status: 'declined',
                }),
            limit: getOptimalLimit(this.$refs.scroll.clientHeight, 75, 12),
          });
          this.nextUrl = data.next;
          this.incomingProjects = data.results;
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
      },
      handleStatusChanging(slug) {
        this.currentStatus = slug;
        this.loadIncomingTenders();
      },
    },
  };
</script>
